import axiosBase from "@/api/axiosBase";

const state = {
}

const getters = {

}

const actions = {
    //新建分享
    addShare({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/share/create',
                data: {
                    "receiver_names": data.receiverNames,
                    "item_ids": data.fileIds,
                    "item_type": data.dataType,
                    "remark": data.remark,
                    "perm": data.perm
                }
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //分享检查用户名
    checkShareUsername({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/auth_center/check_username',
                data: data.username
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //转存
    downloadShare({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/share/dump',
                data: {
                    "share_id": data.shareId,
                    "group_id": data.folderId,
                    "is_clone_result": data.isCloneResult
                }
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //获取分享记录
    getShareDetails({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/share/info',
                data: {
                    "item_type": data.dataType,
                    "is_share4me": data.isShareForMe
                }
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //删除分享
    deleteShare({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/share/delete',
                data: data.ids
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //更新权限
    updateShare({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'POST',
                url: '/share/update',
                data: {
                    "perm": data.perm,
                    "share_id": data.share_id,
                    "remark": data.remark
                }
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}